import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LoadingSpinner } from '@bafkal/ui-shared/components';
import { APP_ROUTES } from '../../../shared/constants';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, initialized } = useSelector((state) => state.auth);

  return (
    <Route
      {...rest}
      render={(props) =>
        // While auth initialization is in progress, show a loader
        !initialized ? (
          <div className="flex items-center justify-center h-64">
            <LoadingSpinner />
          </div>
        ) : isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: APP_ROUTES.LOGIN,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  location: PropTypes.object,
};

export default PrivateRoute;